<template>
  <div>
    <vxe-grid
      ref="listingTable"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="v_tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      cell-class-name="align-top"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:sellType="{ row }">
        <el-tag
          v-if="row.v_sellType"
          size="mini"
          :type="
            row.sellType === 'B'
              ? ''
              : row.sellType === 'C'
              ? 'warning'
              : 'success'
          "
        >
          {{ row.v_sellType || '未配置' }}
        </el-tag>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.storeSkuStatus === 'Y'
              ? 'success'
              : row.storeSkuStatus === 'S' ||
                row.storeSkuStatus === 'B' ||
                row.storeSkuStatus === 'W'
              ? 'danger'
              : row.storeSkuStatus === 'X'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_storeSkuStatus || '未配置状态' }}
        </el-tag>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:displayName="{ row }">
        <span>SKU：</span
        ><span style="color: #303133">{{ row.amzGoodsSkuNo }}</span>
        <br />
        <span>{{ row.brandName }}</span>
        <br />
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC：{{ row.ncNo }}</span>
        <br />
        <span>{{ row.scmName }}</span>
      </template>
      <template v-slot:displaySalesTitle="{ row }">
        <span>{{ row.salesTitle }}</span>
        <br />
        <span>SKU：</span><span style="color: #303133">{{ row.amzSkuNo }}</span>
        <br />
        <span>ASIN：</span
        ><span style="color: #409EFF">{{ row.asinCode }}</span>
        <br />
        <span>FNSKU：</span
        ><span style="color: #409EFF">{{ row.fnskuCode }}</span>
      </template>
      <template v-slot:displayStore="{ row }">
        <span>SHOP：</span
        ><span style="color: #303133">{{ row.amzStoreName }}</span>
        <br />
        <span>BRAND：</span
        ><span style="color: #303133">{{ row.storeBrandName }}</span>
        <br />
        <div>
          <span>METHOD：</span>
          <el-tag
            v-if="row.v_sellType"
            size="mini"
            :type="
              row.sellType === 'B'
                ? ''
                : row.sellType === 'C'
                ? 'warning'
                : 'success'
            "
          >
            {{ row.v_sellType || '未配置' }}
          </el-tag>
        </div>
        <div>
          <span>STATUS：</span>
          <el-tag
            size="mini"
            :type="
              row.storeSkuStatus === 'Y'
                ? 'success'
                : row.storeSkuStatus === 'S' ||
                  row.storeSkuStatus === 'B' ||
                  row.storeSkuStatus === 'W'
                ? 'danger'
                : row.storeSkuStatus === 'X'
                ? 'warning'
                : ''
            "
          >
            {{ row.v_storeSkuStatus || '未配置状态' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: [],
      v_tableData: [],
    }
  },
  watch: {
    tableData: {
      handler(e) {
        this.v_tableData = e
        if (this.v_tableData && this.v_tableData.length > 0) {
          this.tableColumns = tableColumns(this)
          const stockOutPeriodList =
            this.v_tableData[0].stockOutPeriodList || []
          stockOutPeriodList.forEach((f) => {
            this.tableColumns.splice(7, 0, {
              field: f,
              title: f,
              headerAlign: 'center',
              align: 'center',
              minWidth: 200,
            })
          })
          this.v_tableData.forEach((f) => {
            const keys = Object.keys(f.stockOutPeriodMap)
            keys.forEach((key) => {
              f[key] = f.stockOutPeriodMap[key]
            })
          })
        }
      },
    },
  },
  methods: {},
}
</script>
